import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("clients", ["dictionaries"])
  },
  methods: {
    FilterNonActiveBrokers(arr) {
      if (arr) {
        return arr.filter(broker => broker.active !== 0);
      }
      return this.dictionaries.general.brokers.filter(
        broker => broker.active !== 0
      );
    }
  }
};
